import { alpha, type SxProps, type Theme } from "@mui/material/styles";

export const STEPPER_DOT_SIZE = 36;

export const card: SxProps<Theme> = (theme) => ({
  display: { xs: "none", md: "block" },
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 2.5,
  boxShadow: theme.shadows[1],
  p: theme.spacing(3.25, 3.75, 2.75),
});

export const row: SxProps<Theme> = {
  position: "relative",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
};

export const line: SxProps<Theme> = {
  position: "absolute",
  top: STEPPER_DOT_SIZE / 2,
  insetInlineStart: "calc(100% / 12)",
  insetInlineEnd: "calc(100% / 12)",
  height: 3,
  transform: "translateY(-50%)",
  zIndex: 0,
  pointerEvents: "none",
};

export const track: SxProps<Theme> = (theme) => ({
  position: "absolute",
  inset: 0,
  bgcolor: theme.palette.divider,
  borderRadius: 1.5,
});

export const progress = (percent: number): SxProps<Theme> => ({
  position: "absolute",
  top: 0,
  insetInlineStart: 0,
  width: `${percent}%`,
  maxWidth: "100%",
  height: "100%",
  bgcolor: "primary.main",
  borderRadius: 1.5,
  transition: "width 0.3s ease",
});

export const item =
  (clickable: boolean): SxProps<Theme> =>
  () => ({
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
    flex: 1,
    minWidth: 0,
    cursor: clickable ? "pointer" : "default",
    pointerEvents: clickable ? "auto" : "none",
  });

export const dot =
  (state: "done" | "current" | "upcoming"): SxProps<Theme> =>
  (theme) => ({
    width: STEPPER_DOT_SIZE,
    height: STEPPER_DOT_SIZE,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.875rem",
    fontWeight: 700,
    flexShrink: 0,
    bgcolor: "background.paper",
    transition: "all 0.2s ease",
    ...(state === "done" && {
      bgcolor: "primary.main",
      color: "primary.contrastText",
      border: `3px solid ${theme.palette.primary.main}`,
    }),
    ...(state === "current" && {
      bgcolor: "primary.main",
      color: "primary.contrastText",
      border: `3px solid ${theme.palette.primary.light}`,
      boxShadow: `0 0 0 4px ${alpha(theme.palette.primary.main, 0.15)}`,
    }),
    ...(state === "upcoming" && {
      bgcolor: "background.paper",
      color: "text.secondary",
      border: `3px solid ${theme.palette.divider}`,
    }),
  });

export const label =
  (active: boolean): SxProps<Theme> =>
  () => ({
    fontSize: "0.78125rem",
    fontWeight: 600,
    whiteSpace: "nowrap",
    color: active ? "text.primary" : "text.secondary",
  });
